import {ErrorHandler, Injectable} from "@angular/core";
declare let toastr: any;

@Injectable({
  providedIn: 'root'
})
export class AppErrorHandler implements ErrorHandler {

  constructor(){}

  handleError(error: any): void {
    console.log('An unexpected error occurred!.');
    console.log(error);
  }

}